module.exports = __webpack_public_path__ + "img/gushi_1.914fb052.png";